import dataUtils from '@/utils/data-utils';
import { UtilsDependencies, UtilsState } from './../../../models/UtilsState';
import { MutationTree } from 'vuex';

export const UtilsMutations = {
	UPDATE_DEPENDENCIES: 'UPDATE_DEPENDENCIES'
}

export const mutations: MutationTree<any> = {
	[UtilsMutations.UPDATE_DEPENDENCIES] (state: UtilsState, payload: Partial<UtilsDependencies>) {
		state.data = {
			...state.data,
			...payload
		};
		
		dataUtils.setLocalStorageData(state.data);
	}
}
